import React, { useState } from "react";
import styled, { css } from "react-emotion";
import { withRedux } from "helpers";
import * as styles from "../newStyles.styles";
import LoginSignup from "../Authentication/LoginSignup";
import PricingView from "../Pricing/PricingView";

const body = css`
  * {
    *,
    *:before,
    *:after {
      box-sizing: inherit;
    }
  }
  height: 100%;
  margin: 0;
  padding-top: 0.1px;
  overflow-y: hidden;
`;
// classes
const wrapper = css`
  width: 100%;
  margin: 0 auto;
  float: none;
  background-color: #fff;
`;

const header = css`
  margin-bottom: 40px;
`;

const buttonContainerPricing = css`
  text-align: center;
  padding-bottom: 25px;
`;

const mdcButtonCard = css`
  width: 169px;
`;

const mdcButtonLabelFree = css`
  font-size: 12px;
  color: white;
`;

const col = css`
  flex: 0 0 92%;
  margin: auto 4%;
  @media only screen and (min-width: 480px) {
    margin-left: 4%;
    margin-right: 0%;
    text-align: center;
  }
`;

const offwhite = css`
  background-color: #f6fbfb;
  border-radius: 8px 8px 0px 0px;
`;
const col1 = css`
  text-align: center;
`;

const pricingImg2 = css`
  padding: 20px 0px;
  width: 300px;
  @media only screen and (min-width: 480px) {
    width: 500px;
  }
  @media only screen and (min-width: 768px) {
    width: 800px;
  }
`;

const mdcCard = css`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  height: 480px;
  width: 100%;
  justify-content: space-between;
  border-radius: 10px;
  box-shadow: 0 5px 17px 1px rgba(136, 136, 136, 0.5);
  background-color: #ffffff;
  margin-bottom: 55px;
  border-radius: 8px;
  /* cursor: pointer; */

  /* &:hover {
    border: 3px solid #89D2D3;
  } */
`;

const col1_3 = css`
  @media only screen and (min-width: 480px) {
    margin-bottom: 30px;
    margin-left: 2.5%;
  }
  @media only screen and (min-width: 768px) {
    flex: 0 0 30%;
  }
`;

const pricingImg = css`
  padding: 20px 0px;
  width: 175px;
`;

const center = css`
  display: block;
  margin-left: auto;
  margin-right: auto;
`;

const cardText = css`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  white-space: pre-wrap;
`;

const ulCard = css`
  list-style-type: circle;
  color: #89d2d3;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  margin: 20px;
  padding: auto;
  list-style-position: inside;
`;

const firstCardList = css`
  padding-top: 23px;
  @media only screen and (min-width: 1012px) {
    padding-top: 64px;
  }
`;

const thirdCardList = css`
  padding-top: 15px;
  @media only screen and (min-width: 981px) {
    padding-top: 50px;
  }
`;
const sliderLabel = css`
  margin-bottom: 0px;
  margin-left: 25px;
  margin-right: 25px;
  padding-top: 15px;
  justify-content: space-between;
  display: flex;
`;

const small = css`
  margin: 0px;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 11px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #818181;
`;

const smallBlack = css`
  margin: 0px;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 11px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
`;

const slideContainer = css`
  text-align: center;
  width: 100%;
`;

const slider = css`
  -webkit-appearance: none;
  width: 85%;
  height: 8px;
  border-radius: 5px;
  background: rgba(137, 210, 211, 0.3);
  outline: none;
  opacity: 0.7;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
  ::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #89d2d3;
    cursor: pointer;
  }
  ::-moz-range-thumb {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: #4caf50;
    cursor: pointer;
  }
`;

const liCard = css`
  padding-bottom: 5px;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  margin: auto;
  padding: auto;
  text-align: left;
`;

const H4 = styled("h4")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 22px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
  margin: 29px 29px 5px 29px;
`;

const H5 = styled("h5")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #89d2d3;
  margin: 10px 0px;
`;

const P = styled("p")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
`;

function ChoosePlanPricing({ plan, setPlan }) {
  const [sliderProgress, setSliderProgress] = useState(20);
  function inRange(x, min, max) {
    return (x - min) * (x - max) <= 0;
  }
  var formatter = new Intl.NumberFormat("en-US", {
    style: "decimal",
  });
  const appDownloads = () => {
    if (sliderProgress != 1000) {
      // return formatter.format(Math.round(sliderProgress / 10) * 10);
      return formatter.format(Math.round(sliderProgress));
    } else {
      return "1,000";
    }
  };
  const revenue = () => {
    if (appDownloads() != 1000 && appDownloads() != "1,000") {
      return "$" + formatter.format(appDownloads() * 10);
    } else {
      return "$" + formatter.format(1000 * 10);
    }
  };
  const newPrice = () => {
    if (inRange(appDownloads(), 0, 20)) {
      return "$19.99/mo";
    } else if (inRange(appDownloads(), 21, 50)) {
      return "$29.99/mo";
    } else if (inRange(appDownloads(), 51, 100)) {
      return "$49.99/mo";
    } else if (inRange(appDownloads(), 101, 200)) {
      return "$99.99/mo";
    } else if (inRange(appDownloads(), 201, 300)) {
      return "$149.99/mo";
    } else if (inRange(appDownloads(), 301, 400)) {
      return "$199.99/mo";
    } else if (inRange(appDownloads(), 401, 499)) {
      return "$249.99/mo";
    } else if (inRange(appDownloads(), 500, 500)) {
      return "$249.99/mo + $0.50 / additional download";
    } else {
      return "$99.99/mo";
    }
  };

  const tabBorder = (currPlan) => {
    const border = plan === currPlan ? "3px solid #89D2D3" : "none";
    return border;
  };

  return (
    // <div className={body}>
    //   <ThemeProvider
    //     options={{
    //       primary: "#89d2d3",
    //       secondary: "rgb(230, 252, 254)",
    //       background: "#89d2d3",
    //       primaryBg: "#aed9da",
    //       textIconOnBackground: "black",
    //       onPrimary: "white",
    //       textDisabledOnLight: "#89d2d3",

    //       surface: "#89d2d3",
    //       secondaryBg: "#89d2d3",
    //       // textPrimaryOnBackground: '#89d2d3',
    //       textSecondaryOnBackground: "#89d2d3",
    //       textHintOnBackground: "#89d2d3",
    //       textDisabledOnBackground: "#89d2d3",
    //       textPrimaryOnLight: "#89d2d3",
    //       textSecondaryOnLight: "#89d2d3",
    //       textHintOnLight: "#89d2d3",
    //       textIconOnLight: "#89d2d3"
    //     }}
    //   >
    //     <div className={wrapper}>
    //       <h2
    //         style={{
    //           margin: "25px 50px"
    //         }}
    //       >
    //         Our Plans
    //       </h2>
    //       <div
    //         style={{
    //           display: "flex",
    //           margin: "0px 50px"
    //         }}
    //       >
    //         {/*Cards Row*/}
    //         <div className={col + " " + col1_3}>
    //           <div
    //             className={mdcCard}
    //             // onClick={() => setPlan('starter')}
    //             style={{
    //               border: "3px solid #89D2D3"
    //             }}
    //           >
    //             <div className={offwhite}>
    //               <H4>Starter</H4>
    //               <H5>Free 30 Days, After Publishing!</H5>
    //             </div>
    //             <img
    //               src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/couple copy@2x.png"
    //               className={pricingImg + " " + center}
    //             ></img>
    //             <ul className={ulCard + " " + firstCardList}>
    //               <li className={liCard}>
    //                 <span className={cardText}>
    //                   Build your app, then 30 days free after going live!
    //                 </span>
    //               </li>
    //               <li className={liCard}>
    //                 <span className={cardText}>
    //                   App hosted on the Mobile360 marketplace
    //                 </span>
    //               </li>
    //               <li className={liCard}>
    //                 <span className={cardText}>
    //                   Customer Insights and Analytics
    //                 </span>
    //               </li>
    //             </ul>
    //           </div>
    //         </div>
    //         <div className={col + " " + col1_3}>
    //           <div
    //             className={mdcCard}
    //             // onClick={() => setPlan('plus')}
    //             // style={{
    //             //   border: tabBorder('plus')
    //             // }}
    //           >
    //             <div className={offwhite}>
    //               <H4>Plus</H4>
    //               <H5>
    //                 <span>{newPrice()}</span>
    //               </H5>
    //             </div>
    //             <div className={sliderLabel}>
    //               <P className={small}>0</P>
    //               <P className={small}>500+</P>
    //             </div>

    //             <div className={slideContainer}>
    //               <input
    //                 onChange={e => setSliderProgress(e.target.value)}
    //                 type="range"
    //                 min="0"
    //                 max="500"
    //                 value={sliderProgress}
    //                 className={slider}
    //               />
    //               <P className={smallBlack}>
    //                 <span></span>
    //                 {appDownloads()} app downloads
    //               </P>
    //               <img
    //                 src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/undraw_Queue_j6ij Copy@2x.png"
    //                 className={pricingImg + " " + center}
    //               ></img>
    //             </div>

    //             <ul
    //               className={ulCard + " " + firstCardList}
    //               style={{
    //                 paddingTop: "24px"
    //               }}
    //             >
    //               <li className={liCard}>
    //                 <span className={cardText}>
    //                   Price dependent on downloads. See pricing meter above.
    //                 </span>
    //               </li>
    //               <li className={liCard}>
    //                 <span className={cardText}>
    //                   App hosted on the Mobile360 marketplace
    //                 </span>
    //               </li>
    //               <li className={liCard}>
    //                 <span className={cardText}>
    //                   Customer Insights and Analytics
    //                 </span>
    //               </li>
    //               <li className={liCard}>
    //                 <span className={cardText}>
    //                   Dedicated Customer Support Representative
    //                 </span>
    //               </li>
    //             </ul>
    //           </div>
    //         </div>
    //         <div className={col + " " + col1_3}>
    //           <div
    //             className={mdcCard}
    //             // onClick={() => setPlan('premium')}
    //             // style={{
    //             //   border: tabBorder('premium')
    //             // }}
    //           >
    //             <div className={offwhite}>
    //               <H4>Premium</H4>
    //               <H5>Contact for Details</H5>
    //             </div>
    //             <img
    //               src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/team@2x.png"
    //               className={pricingImg + " " + center}
    //             ></img>
    //             <ul className={ulCard + " " + thirdCardList}>
    //               <li className={liCard}>
    //                 <span className={cardText}>No Mobile360 branding</span>
    //               </li>
    //               <li className={liCard}>
    //                 <span className={cardText}>
    //                   App hosted on the App Store
    //                 </span>
    //               </li>
    //               <li className={liCard}>
    //                 <span className={cardText}>
    //                   Customer Insights and Analytics
    //                 </span>
    //               </li>
    //               <li className={liCard}>
    //                 <span className={cardText}>
    //                   Dedicated Customer Support Representative
    //                 </span>
    //               </li>
    //             </ul>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </ThemeProvider>
    //   <div
    //     style={{
    //       position: "absolute",
    //       bottom: "40px",
    //       left: "60px"
    //     }}
    //   >
    //     <p>
    //       You'll automatically be enrolled into our free <b>Starter Plan</b>
    //     </p>
    //   </div>
    // </div>
    <div className={body}>
      <div className={wrapper}>
        {/* <div className={styles.row + " " + header}>
            <div
              className={styles.col + " " + styles.col1_4_header}
              onClick={goToRoot}
            >
              <img
                src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/logo_small.png"
                alt="header-logo"
                className={styles.headerLogoPic}
              />
            </div>
            <div
              className={styles.col + " " + styles.col3header}
              style={{ textAlign: "right" }}
            >
              <MenuToggler
                history={history}
                menuOptions={menuOptions}
              ></MenuToggler>
            </div>
          </div> */}
        <div className={styles.row} style={{ overflow: "auto" }}>
          {/*We Get It*/}
          <div className={col + " " + col1}>
            <H4>Select a Plan</H4>
            {/* <P>
                You don’t want to pay for something until you know how it works.{" "}
                <br></br>That’s why we’re offering a free 30 day trial that only
                starts<br></br>after you publish your app to your customers.
              </P> */}
            {/* <LoginSignup buttonText="Try Building Your Free App Now!" /> */}
            {/* <img
              src="https://mobile360-assets.s3.us-east-2.amazonaws.com/pricing.png"
              className={pricingImg2 + " " + center}
            ></img> */}
            <PricingView showActions={true} setPlan={setPlan} plan={plan} />
            {/* <LoginSignup
                buttonText="Get Started for Free"
                width="550px"
                fontWeight="bold"
                fontSize="20px"
              /> */}
          </div>
        </div>
        {/*<div className={styles.row}>

            <div className={col + " " + col1_3}>
              <div className={mdcCard}>
                <div className={offwhite}>
                  <H4>Starter</H4>
                  <H5>Free 30 Days, After Publishing!</H5>
                </div>
                <img
                  src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/couple copy@2x.png"
                  className={pricingImg + " " + center}
                ></img>
                <ul className={ulCard + " " + firstCardList}>
                  <li className={liCard}>
                    <span className={cardText}>
                      Build your app, then 30 days free after going live!
                    </span>
                  </li>
                  <li className={liCard}>
                    <span className={cardText}>
                      App hosted on the Mobile360 marketplace
                    </span>
                  </li>
                  <li className={liCard}>
                    <span className={cardText}>
                      Customer Insights and Analytics
                    </span>
                  </li>
                </ul>
                <div className={buttonContainerPricing}>
                  <LoginSignup buttonText="Get Started For Free!" />
                </div>
              </div>
            </div>
            <div className={col + " " + col1_3}>
              <div className={mdcCard}>
                <div className={offwhite}>
                  <H4>Plus</H4>
                  <H5>
                    <span>{newPrice()}</span>
                  </H5>
                </div>
                <div className={styles.row + " " + sliderLabel}>
                  <P className={small}>0</P>
                  <P className={small}>500+</P>
                </div>

                <div className={slideContainer}>
                  <input
                    onChange={e => setSliderProgress(e.target.value)}
                    type="range"
                    min="0"
                    max="500"
                    value={sliderProgress}
                    className={slider}
                  />
                  <P className={smallBlack}>
                    <span></span>
                    {appDownloads()} app downloads
                  </P>
                  <img
                    src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/undraw_Queue_j6ij Copy@2x.png"
                    className={pricingImg + " " + center}
                  ></img>
                </div>

                <ul
                  className={ulCard + " " + firstCardList}
                  style={{
                    paddingTop: "24px"
                  }}
                >
                  <li className={liCard}>
                    <span className={cardText}>
                      Price dependent on downloads. See pricing meter above.
                    </span>
                  </li>
                  <li className={liCard}>
                    <span className={cardText}>
                      App hosted on the Mobile360 marketplace
                    </span>
                  </li>
                  <li className={liCard}>
                    <span className={cardText}>
                      Customer Insights and Analytics
                    </span>
                  </li>
                  <li className={liCard}>
                    <span className={cardText}>
                      Dedicated Customer Support Representative
                    </span>
                  </li>
                </ul>
                <div className={buttonContainerPricing}>
                  <LoginSignup buttonText="Get Started For Free!" />
                </div>
              </div>
            </div>
            <div className={col + " " + col1_3}>
              <div className={mdcCard}>
                <div className={offwhite}>
                  <H4>Premium</H4>
                  <H5>Contact for Details</H5>
                </div>
                <img
                  src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/team@2x.png"
                  className={pricingImg + " " + center}
                ></img>
                <ul className={ulCard + " " + thirdCardList}>
                  <li className={liCard}>
                    <span className={cardText}>No Mobile360 branding</span>
                  </li>
                  <li className={liCard}>
                    <span className={cardText}>
                      App hosted on the App Store
                    </span>
                  </li>
                  <li className={liCard}>
                    <span className={cardText}>
                      Customer Insights and Analytics
                    </span>
                  </li>
                  <li className={liCard}>
                    <span className={cardText}>
                      Dedicated Customer Support Representative
                    </span>
                  </li>
                </ul>
                <div className={buttonContainerPricing}>
                  <Button
                    className={styles.mdcButton + " " + mdcButtonCard}
                    raised
                    style={{ width: "179px" }}
                  >
                    <span className={mdcButtonLabelFree}>
                      <a
                        style={{
                          color: "inherit",
                          textTransform: "capitalize",
                          textDecoration: "none",
                          fontSize: ".875rem",
                          lineHeight: " 2.25rem",
                          fontWeight: "500",
                          letterSpacing: ".0892857143em"
                        }}
                        href="mailto: team@mobile360.io?subject=Hey Mobile360, I have a question for you!"
                      >
                        Contact for Details
                      </a>
                    </span>
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.col + " " + styles.col1}>
              <P>
                With{" "}
                <span style={{ color: "#89D2D3", fontSize: "20px" }}>
                  {appDownloads()}
                </span>{" "}
                of your customers on Mobile360, you can achieve up to{" "}
                <span style={{ color: "#89D2D3", fontSize: "20px" }}>
                  {revenue()}
                </span>{" "}
                in additional revenue. Move the slider around to see more!
              </P>
              <P>
                *Based on an average additonal spend of $10 per customer per
                month, through your app!
              </P>
            </div>
          </div> */}
      </div>
    </div>
  );
}

export default withRedux(ChoosePlanPricing);
